import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../utils/api";

function Landing() {
  const navigate = useNavigate();
  const [showAdminInput, setShowAdminInput] = useState(false);
  const [adminCode, setAdminCode] = useState("");

  const handleAdminLogin = async () => {
    try {
      const res = await api.post("/auth/admin-login", { adminCode });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.role);
      navigate("/admin");
    } catch (err) {
      alert("❌ الكود غير صحيح أو حصل خطأ");
    }
  };

  return (
    <div
      className="h-screen w-full bg-cover bg-center flex flex-col items-center justify-center text-white relative overflow-hidden"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
      }}
    >
      {/* 🔥 Overlay متدرج متحرك */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-black/70 via-gray-900/60 to-black/70"
        animate={{ backgroundPosition: ["0% 0%", "100% 100%", "0% 0%"] }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
      />

      {/* ✨ رسالة الترحيب (أنيميشن مميز) */}
      <motion.div
        initial={{ opacity: 0, scale: 0.5, rotate: -10 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 1.2, type: "spring", bounce: 0.4 }}
        className="relative z-20 mb-10 text-center"
      >
        <h1 className="text-4xl md:text-6xl font-extrabold">
          👋 أهلاً بيك في{" "}
          <motion.span
            animate={{
              textShadow: [
                "0 0 5px #FFD700",
                "0 0 20px #FFA500",
                "0 0 5px #FFD700",
              ],
              scale: [1, 1.1, 1],
            }}
            transition={{ repeat: Infinity, duration: 2 }}
            className="text-yellow-400"
          >
            الأفوكاتوا
          </motion.span>
        </h1>
      </motion.div>

      {/* ✨ باقي الصفحة */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0, y: 40 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { staggerChildren: 0.3 },
          },
        }}
        className="relative z-10 text-center"
      >
        {showAdminInput ? (
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="bg-gray-900 p-6 rounded-lg shadow-2xl inline-block"
          >
            <input
              type="password"
              className="p-3 rounded bg-gray-700 text-white mb-4 w-64"
              placeholder="ادخل كود مدير النظام"
              value={adminCode}
              onChange={(e) => setAdminCode(e.target.value)}
            />
            <button
              onClick={handleAdminLogin}
              className="w-full bg-yellow-500 text-black font-bold p-3 rounded-lg hover:bg-yellow-600 transition"
            >
              دخول كمدير النظام
            </button>
          </motion.div>
        ) : (
          <div className="flex flex-col md:flex-row gap-6 justify-center">
            <motion.button
              whileHover={{ scale: 1.1, rotate: 2 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-yellow-500 text-black font-bold rounded-lg shadow-xl hover:bg-yellow-600 transition"
              onClick={() => {
                localStorage.setItem("role", "محامي رئيسي");
                navigate("/login");
              }}
            >
              👨‍⚖️ دخول كمحامي رئيسي
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.1, rotate: -2 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-gray-800 text-yellow-400 font-bold rounded-lg border border-yellow-400 shadow-xl hover:bg-gray-700 transition"
              onClick={() => {
                localStorage.setItem("role", "محامي مساعد");
                navigate("/join");
              }}
            >
              👨‍💼 دخول كمحامي مساعد
            </motion.button>
          </div>
        )}
      </motion.div>
    </div>
  );
}

export default Landing;
